module.exports = __webpack_public_path__ + "static/media/stationen.ffbe88b3.png";